import React from 'react';

const Contact = () => {
    return (
        <div id="contact" className='py-24 lg:py-32 px-6 md:px-12 lg:px-2'>
            <div className='lg:max-w-[1100px] mx-auto flex flex-row lg:flex-col justify-center'>
                <div>
                    <div className='text-center'>
                        <h2 className='text-2xl text-[#2979ff] uppercase font-bold '>Get In Touch</h2>
                        <p className='pt-8 text-[17px] '>
                            I’m currently looking for new opportunities, my inbox is always open. Whether <br /> you have a question or just want to say hi, I’ll try my best to get back to you!
                        </p>
                    </div >
                    <div className='flex justify-center mt-10'>
                        <a className="text-[#2979ff] bg-transparent font-semibold border-2 border-[#2979ff] py-2 px-6 rounded hover:bg-[#2979ff] hover:text-white duration-500 transition" href="mailto:bikashdevsharma99@gmail.com">
                            Say Hello
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;